import { ModelSagres } from "@/types/model-sagres";

export interface RespostaAvaliacaoJson {
  dimensao: string;
  itemId: string;
  serigyItem: string;
  serigySchema: string;
  ponto: boolean;
  detalhe: string;
}

export class RespostaAvaliacao extends ModelSagres {
  dimensao: string;
  itemId: string;
  serigyItem: string;
  serigySchema: string;
  ponto: boolean;
  detalhe: string;

  codigo?: string;
  mensagem?: string;
  corIcone?: string;
  icone?: string;

  /**
   * @param obj
   */
  constructor(obj?: RespostaAvaliacaoJson) {
    super();
    if (obj) {
      Object.assign(this, obj)
      if(obj.detalhe !== null && obj.detalhe.includes('|')){
        this.codigo = obj.detalhe.split('|')[0]
        this.mensagem = obj.detalhe.split('|')[1]
      }
    }
    this.icone = this.ponto ? 'check' : 'exclamation-triangle'
    this.corIcone = this.ponto ? 'text-success' : 'text-warning'
  }
}
